import React from 'react';
import classNames from 'classnames/bind';
import { Typography } from '../Typography/Typography';
import styles from './NumericalSubtitle.module.scss';
import { EditIcon } from '../../assets/icons/EditIcon';

const cx = classNames.bind(styles);

export interface INumericalSubtitleProps {
  number: string;
  subtitle: string;
  isCompact?: boolean;
  onEditClick?: () => void;
}

export const NumericalSubtitle = ({ number, subtitle, isCompact = false, onEditClick }: INumericalSubtitleProps) => {
  return (
    <div
      className={cx({
        content: !isCompact,
        'compact-content': isCompact,
      })}
    >
      <div className={styles['section-number']}>
        <Typography color="secondary" weight="bold" className={styles['section-number-text']}>
          {number}
        </Typography>
      </div>
      <Typography size="XL" weight="semi-bold" color="primary">
        {subtitle}
      </Typography>
      {onEditClick && (
        <button
          className={styles['edit-button']}
          onClick={onEditClick}
          aria-label={`${subtitle.toLowerCase().replaceAll(' ', '-')}-edit-button`}
        >
          <EditIcon size="small" />
        </button>
      )}
    </div>
  );
};
